import { Component } from '@angular/core';
import {WikipediaService} from './wikipedia.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  pages = [];

  constructor(private wikipedia:WikipediaService){

  }
  onSubmitted(values:string){
    this.wikipedia.search(values).subscribe((response)=>{
      console.log(response);
        this.pages = response;
    })
  }
}
